import { Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import OutboundCallCallHistory from './OutboundCallCallHistory';
import InboundCallHistory from './InboundCallHistory';

export default function CallHistoryContainer() {
    const [value, setValue] = useState(0)
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div>
            <Tabs value={value} onChange={handleChange} >
                <Tab label="Incoming Calls" />
                <Tab label="Outgoing Calls"></Tab>
            </Tabs>
            <br></br><br></br>
            {
                value === 0 && <>
                    <InboundCallHistory></InboundCallHistory>
                </>
            }
            {
                value === 1 && <>
                    <OutboundCallCallHistory></OutboundCallCallHistory>
                </>
            }
        </div>
    )
}
